import React from "react";
import * as Sentry from "@sentry/react";
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom";

Sentry.init({
  dsn: "https://2ceeb0fd63796991041f79a2fdbe62bb@o4506798074232832.ingest.us.sentry.io/4512215574773760",
  environment: process.env.REACT_APP_APP_ENV,

  integrations: [
    Sentry.reactRouterBrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],

  // Capture 100% of transactions; lower this in production if volume grows.
  tracesSampleRate: 1.0,
});
